export default "__VITE_ASSET__BHWdeMbz__"